"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FieldWrapper = _styledComponents.default.div.withConfig({
  displayName: "Field__FieldWrapper",
  componentId: "design-system__ja6hzt-0"
})(["& + .Field{margin-top:2rem;}label{padding-top:0;}.message,.error{color:", ";font-family:", ";font-size:", ";display:flex;justify-content:space-between;margin-top:0.5rem;}.error{color:", ";}"], _BaseTheme.default.colors.lightgray, _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.small, _BaseTheme.default.colors.red);

const FieldGroup = _styledComponents.default.div.withConfig({
  displayName: "Field__FieldGroup",
  componentId: "design-system__ja6hzt-1"
})(["display:flex;& .Field + .Field,& div + div{margin-left:20px;margin-top:0;}"]);

const Field = _ref => {
  let {
    children,
    messageLeft,
    messageRight,
    error
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(FieldWrapper, {
    className: "Field"
  }, children, (!!messageLeft || !!messageLeft) && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("span", null, messageLeft), /*#__PURE__*/_react.default.createElement("span", null, messageRight)), !!error && /*#__PURE__*/_react.default.createElement("span", {
    className: "error"
  }, error));
};

Field.Group = FieldGroup;
Field.Row = FieldGroup;
Field.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element]).isRequired,
  messageLeft: _propTypes.default.string,
  messageRight: _propTypes.default.string,
  error: _propTypes.default.string
};
Field.defaultProps = {
  messageLeft: '',
  messageRight: '',
  error: ''
};
var _default = Field;
exports.default = _default;